<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="header">
                <mat-card-title> {{"MASCHINESTATE.DRIVE.HEADER" | translate}}</mat-card-title>

                
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">

                    <div class="container">
                        <div class="img-container img-wrapper">
                            <img class="img" src="../../../../../assets/images/drive/fahrantrieb.svg"/>
                        </div>

                        <!-- EngineSpeed 447 -->
                        <div class="overlay" style="top: 117px; left: 425px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.ENGINE_SPEED' | translate}}" matTooltipPosition="below">
                            {{this.driveMultiDataset.dataPoints[0].value}} {{this.driveMultiDataset.dataPoints[0].unit}}
                        </div>

                        <!-- DriveForwardCurrent 305 -->
                        <ng-container *ngIf="currentGear == 'F' || currentGear == 'N'">
                            <div class="overlay" style="top: 225px; left: 618px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.DRIVE_FORWARD' | translate}}" matTooltipPosition="below">
                                {{this.driveMultiDataset.dataPoints[1].value}} {{this.driveMultiDataset.dataPoints[1].unit}}
                            </div>
                        </ng-container>
                        <!-- DriveBackwardCurrent 306 -->
                        <ng-container *ngIf="currentGear == 'R'">
                            <div class="overlay" style="top: 225px; left: 618px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.DRIVE_BACKWARD' | translate}}" matTooltipPosition="below">
                                {{this.driveMultiDataset.dataPoints[2].value}} {{this.driveMultiDataset.dataPoints[2].unit}}
                            </div>
                        </ng-container>

                        <!-- PressureDrive 282-->
                        <div class="overlay" style="top: 261px; left: 440px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.PRESSURE_DRIVE' | translate}}" matTooltipPosition="below">
                            {{this.driveMultiDataset.dataPoints[3].value}} {{this.driveMultiDataset.dataPoints[3].unit}}
                        </div>

                        <!-- HydrostatSpeedActual 726-->
                        <div class="overlay" style="top: 315px; left: 570px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.HYDRO_SPEED' | translate}}" matTooltipPosition="below">
                            {{this.driveMultiDataset.dataPoints[4].value}} {{this.driveMultiDataset.dataPoints[4].unit}}
                        </div>

                        <!-- KardanSpeed 656-->
                        <div class="overlay" style="top: 373px; left: 605px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.KARDAN_SPEED' | translate}}" matTooltipPosition="below">
                            {{this.driveMultiDataset.dataPoints[5].value}} {{this.driveMultiDataset.dataPoints[5].unit}}
                        </div>

                        <!-- HydrostatDisplacmentCurrent 429 -->
                        <div class="overlay" style="top: 315px; left: 310px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.HYDRO_DISPLACEMENT' | translate}}" matTooltipPosition="below">
                            {{this.driveMultiDataset.dataPoints[6].value}} {{this.driveMultiDataset.dataPoints[6].unit}}
                        </div>

                        <!-- ActualVelocity 725 -->
                        <div class="overlay" style="top: 117px; left: 200px; width: 130px;" #tooltip="matTooltip" matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.ACT_VELO' | translate}}" matTooltipPosition="below">
                            {{this.driveMultiDataset.dataPoints[7].value}} {{this.driveMultiDataset.dataPoints[7].unit}}
                        </div>

                        <!-- OptionHeavyDutyHighSpeedAxleOut 779 -->
                        <ng-container *ngIf="this.driveMultiDataset.dataPoints[10]">
                            <div class="overlay axle" style="top: 63px; left: 715px; width: 350px;">
                                <div>{{ "MASCHINESTATE.DRIVE.AXLE_TYPE" | translate }}:</div>
                                <ng-container *ngIf="this.driveMultiDataset.dataPoints[10].value === 1">{{ "MASCHINESTATE.DRIVE.HD_HIGH_SPEED" | translate }}</ng-container>
                                <ng-container *ngIf="this.driveMultiDataset.dataPoints[10].value === 0">{{ "MASCHINESTATE.DRIVE.HD_STANDARD" | translate }}</ng-container>
                            </div>
                        </ng-container>

                        <!-- OptionTireRollingCircumferenceOut 795 -->
                        <ng-container *ngIf="this.driveMultiDataset.dataPoints[11]">
                            <div class="overlay axle" style="top: 90px; left: 715px; width: 350px;">
                                <div>{{ "MASCHINESTATE.DRIVE.TIRE_CIRCUM" | translate }}:</div>
                                <div>{{this.driveMultiDataset.dataPoints[11].value}} {{this.driveMultiDataset.dataPoints[11].unit}}</div>
                            </div>
                        </ng-container>

                        <!-- GEAR  HydrostatDirectionGearSelectionActual 723 -->
                        <div 
                            class="overlay val gear"
                            [class.active]="gearActive"
                            style="top: 553px; left: 478px;"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.GEAR' | translate}}" 
                            matTooltipPosition="below"
                        > {{currentGear}}</div>

                        <!-- BREAK ParkingBrakeClosed 657-->
                        <div 
                            class="overlay val break"
                            style="top: 553px; left: 575px;"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'MASCHINESTATE.DRIVE.TOOLTIP.BREAK' | translate}}" 
                            matTooltipPosition="below"
                        >
                            <mat-icon svgIcon="break" class="large-icon" [class.active]="breakActive"></mat-icon>
                        </div>
                    </div>

                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
